import React, { useState, useCallback, useEffect } from 'react'
import { Container } from '~/styles/tabela1';
import { Loader, Table, FlexboxGrid, Input, InputGroup, IconButton, Button } from 'rsuite';
import { Attachment, Search } from '@rsuite/icons';
import { GerarCSV as CSV } from '~/utils/gerarCSV'
import { startOfMonth, format, parseISO, lastDayOfMonth } from 'date-fns';
import { InputDataRange } from '~/components/InputDataRange';
import { TableHeaderTooltip, TablePagination } from '~/components/TablePagination1';
import { ModalPadrao } from '~/components/Modal';
import api from '~/services/api';
import { toast } from 'react-toastify';
import { ColContainer, RowContainer } from './styles'
import fortCurrency from '../../../utils/formatCurrency'
import ModalEnviarNotificacaoAnalise from './components/ModalEnviarAnaliseRecorrencia';
import PageHeader from '../../../components/PageHeader';
import Card from '../../../components/Card';




const AnaliseRecorrencia = () => {
  const { HeaderCell, Column, Cell } = Table;
  const [filtroNome, setFiltroNome] = useState('');
  const modalTitulo = 'Gerar CSV'
  const modalTexto = 'Tem certeza que deseja gerar este CSV com os filtros atuais?'
  const [pagina, setPagina] = useState(1);
  const [modalLoading, setModalLoading] = useState(false);
  const [semPedidoFiltro, setSemPedidoFiltro] = useState([]);
  const [comPedidoFiltro, setComPedidoFiltro] = useState([]);
  const [modalCSV, setModalCSV] = useState(false)
  const [buscarCSV, setBuscarCSV] = useState(false)
  const [clientes, setClientes] = useState({
    estabelecimentos: [],
  });
  const [carregando, setCarregando] = useState(false);
  const [orderBy, setOrderBy] = useState('');
  const locale = {
    sunday: 'Dom',
    monday: 'Seg',
    tuesday: 'Ter',
    wednesday: 'Qua',
    thursday: 'Qui',
    friday: 'Sex',
    saturday: 'Sab',
    ok: 'Ok',
    today: 'Hoje',
    yesterday: 'Ontem',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
  };

  const buscarClientes = useCallback(async () => {
    setCarregando(true);
    setModalLoading(true)
    try {
      const resposta = await api.get(
        `relatorios/estabelecimento/analise-recorrencia`,
        {
          params: {
            pagina,
            nome: filtroNome,
            orderBy,
            csv: buscarCSV,
            periodoComPedido: comPedidoFiltro,
            periodoSemPedido: semPedidoFiltro
          },
        }
      );
      const lista = resposta.data.lista.map((map) => ({
        ...map,
        data_ativacao: format(parseISO(map.data_ativacao), 'dd/LL/yyyy'),
        valor_bruto: fortCurrency(map.valor_bruto),
        ultimo_pedido: format(parseISO(map.ultimo_pedido), 'dd/LL/yyyy')
      }));

      if (buscarCSV) {
        CSV({
          data: lista,
          download: true,
        });
        setCarregando(false)
        setModalLoading(false);
        toast.success(`Foram exportados ${lista.length} relatórios.`);
        setBuscarCSV(false);
        setModalCSV(false)
        return;
      }

      setClientes({
        quantidade: lista.length > 0 ? lista[0].full_count : 0,
        lista
      });
      if (clientes.quantidade === 0) setPagina(1)
    } catch (e) {
      toast.error(e.message);
    }
    setCarregando(false);
    setModalLoading(false);
  }, [pagina, filtroNome, comPedidoFiltro, semPedidoFiltro, orderBy, clientes.quantidade, buscarCSV])

  useEffect(() => {
    buscarClientes();
  }, [buscarClientes]);





  return (



    <Container>
      <PageHeader
        title="Análise de Recorrência"
        subtitle="Análise de Recorrência"
        actions={(

          <Button
            appearance="ghost"
            startIcon={<Attachment />}
            onClick={() => {
              setModalCSV(true);
            }}
          >
            Exportar CSV
          </Button>
        )}
      />
      <Card>
        <RowContainer>
          <ColContainer>
            <InputGroup style={{ width: '300px', marginRight: '15px' }}>
              <Input
                name="nome_estabelecimento"
                value={filtroNome}
                style={{ marginRight: '10px', width: '300px' }}
                placeholder="Nome do Cliente"
                onChange={setFiltroNome}
              />
              <InputGroup.Button>
                <Search />
              </InputGroup.Button>
            </InputGroup>
          </ColContainer>
          <ColContainer>
            <InputDataRange
              name="data"
              style={{ marginRight: '15px', width: '250px' }}
              ranges={[]}
              isoWeek
              locale={locale}
              onChange={setComPedidoFiltro}
              value={comPedidoFiltro}
              placeholder='Data com pedido no período'
            />
          </ColContainer>
          <ColContainer>
            <InputDataRange
              name="data"
              style={{ marginRight: '15px', width: '250px' }}
              ranges={[]}
              isoWeek
              locale={locale}
              onChange={setSemPedidoFiltro}
              value={semPedidoFiltro}
              placeholder='Data sem pedido no período'
            />

          </ColContainer>
          <ModalEnviarNotificacaoAnalise
            style={{ marginBottom: '20px' }}
            filtroNome={filtroNome}
            comPedidoFiltro={comPedidoFiltro}
            semPedidoFiltro={semPedidoFiltro}
          />
        </RowContainer>

        <FlexboxGrid style={{ width: '100%' }}>
          <TablePagination
            carregando={carregando}
            dados={clientes.lista}
            quantidade={clientes.quantidade || 0}
            onChangePage={setPagina}
            setOrderBy={setOrderBy}
          >
            <Column resizable width={240} sortable>
              <HeaderCell>
                <TableHeaderTooltip label="Nome Estabelecimento" tooltip="Nome Estabelecimento" />
              </HeaderCell>
              <Cell dataKey="nome_fantasia" />
            </Column>

            <Column resizable width={160}>
              <HeaderCell>
                <TableHeaderTooltip label="Cnpj" tooltip="Cnpj" />
              </HeaderCell>
              <Cell dataKey="cpf_cnpj" />
            </Column>
            <Column resizable width={150} sortable>
              <HeaderCell>
                <TableHeaderTooltip label="Cidade" tooltip="Cidade" />
              </HeaderCell>
              <Cell dataKey="cidade" />
            </Column>
            <Column resizable width={90} sortable>
              <HeaderCell>
                <TableHeaderTooltip label="Estado" tooltip="Estado" />
              </HeaderCell>
              <Cell dataKey="uf" />
            </Column>
            <Column resizable width={130} sortable>
              <HeaderCell>
                <TableHeaderTooltip label="Data Ativação" tooltip="Data Ativação" />
              </HeaderCell>
              <Cell dataKey="data_ativacao" />
            </Column>
            <Column resizable width={120} sortable>
              <HeaderCell>
                <TableHeaderTooltip label="Quantidade" tooltip="Quantidade" />
              </HeaderCell>
              <Cell dataKey="count" />
            </Column>
            <Column resizable width={110} sortable>
              <HeaderCell>
                <TableHeaderTooltip label="Total" tooltip="Total" />
              </HeaderCell>
              <Cell dataKey="valor_bruto" />
            </Column>
            <Column resizable width={130} sortable>
              <HeaderCell>
                <TableHeaderTooltip label="Ultimo Pedido" tooltip="Ultimo Pedido" />
              </HeaderCell>
              <Cell dataKey="ultimo_pedido" />
            </Column>
          </TablePagination>
        </FlexboxGrid>
      </Card>


      <ModalPadrao
        openModal={modalCSV}
        carregando={modalLoading}
        // csv
        setOpenModal={setModalCSV}
        title={modalTitulo}
        text={modalTexto}
        funcExec={() => {
          setBuscarCSV(true);
          buscarClientes()
        }}
      />

      {carregando && <Loader center size="lg" vertical />}
    </Container>
  )
}

export default AnaliseRecorrencia
